import { convertHeicToJpeg, isHeicOrHeifFile } from './convertHeicToJpeg'

export const MAX_FILE_NAME_LENGTH = 120

type TranslateFunction = (key: string) => string

type PrepareAttachmentFileForUploadOptions = {
  maxFileSizeInBytes: number
  t: TranslateFunction
}

type PrepareAttachmentFileForUploadResult = {
  file: File | null
  errorMessage: string | null
}

export async function prepareAttachmentFileForUpload(
  file: File,
  options: PrepareAttachmentFileForUploadOptions
): Promise<PrepareAttachmentFileForUploadResult> {
  if (!isHeicOrHeifFile(file)) {
    return { file, errorMessage: null }
  }

  let convertedFile: File
  try {
    convertedFile = await convertHeicToJpeg(file)
  } catch (reason) {
    return { file: null, errorMessage: 'ERROR: ' + reason }
  }

  if (convertedFile.size > options.maxFileSizeInBytes) {
    return {
      file: null,
      errorMessage: options.t('uploadFile.err3'),
    }
  }

  if (convertedFile.name.length > MAX_FILE_NAME_LENGTH) {
    return {
      file: null,
      errorMessage: options.t('uploadFile.nameTooLong'),
    }
  }

  return { file: convertedFile, errorMessage: null }
}
